module.exports = __webpack_public_path__ + "static/media/3.079ddd2a.png";